// channelHelpers — derive the messaging-v2 channels view from a branch info
// object. Crucially, when channels.{} is empty (legacy branch never migrated),
// we synthesize channel_2 from the legacy `whatsapp_provider.{login, state}`
// fields so the new UI shows the same QR + status the user has always seen.
//
// channel_1 is synthesized as connected only when the legacy provider is
// `dialogue360` — every other legacy provider lands on channel_2.
//
// Provider implementation names never leave this module; UI components only
// read the synthesized {enabled, connection_state, phone, display_handle}
// shape that mirrors the live channels schema.

const PROVIDER_BRANDED = new Set(["dialogue360", "waba"]);

export function deriveChannelsView(info) {
  const wp = info?.configuration?.whatsapp_provider || {};
  const liveChannels = wp.channels || {};
  const hasLive =
    !!liveChannels.channel_1 || !!liveChannels.channel_2;

  if (hasLive) {
    return {
      channel_1: normalizeChannel(liveChannels.channel_1),
      channel_2: normalizeChannel(liveChannels.channel_2),
      legacyShim: false,
    };
  }

  // Legacy fallback: synthesize from flat whatsapp_provider fields. Old
  // branches keep their exact pre-v2 UX — QR-first, no WABA visible if they
  // don't have it.
  const legacyConnected = !!wp.state;
  const isBrandedLegacy = PROVIDER_BRANDED.has(wp.provider);
  return {
    channel_1: isBrandedLegacy
      ? {
          enabled: legacyConnected,
          display_name: "WhatsApp Business (WABA)",
          connection_state: legacyConnected ? "connected" : "not_connected",
          phone: wp.login || "",
          display_handle: "",
        }
      : { enabled: false, display_name: "WhatsApp Business (WABA)", connection_state: "not_connected", phone: "", display_handle: "" },
    channel_2: !isBrandedLegacy
      ? {
          enabled: legacyConnected,
          display_name: "Личный канал",
          connection_state: legacyConnected ? "connected" : "not_connected",
          phone: wp.login || "",
          display_handle: "",
        }
      : { enabled: false, display_name: "Личный канал", connection_state: "not_connected", phone: "", display_handle: "" },
    legacyShim: true,
  };
}

function normalizeChannel(ch) {
  if (!ch) {
    return {
      enabled: false,
      display_name: "",
      connection_state: "not_connected",
      phone: "",
      display_handle: "",
    };
  }
  return {
    enabled: !!ch.enabled,
    display_name: ch.display_name || "",
    connection_state: ch.connection_state || "not_connected",
    phone: ch.phone || "",
    display_handle: ch.display_handle || "",
  };
}

export function isChannelConnected(channel) {
  return !!channel && channel.enabled && channel.connection_state === "connected";
}

export function bothChannelsConnected(view) {
  return isChannelConnected(view.channel_1) && isChannelConnected(view.channel_2);
}
